import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { selectCompanyInfo } from '../../header/companyInfo/store/slice'
import Button from './Button'
import { jsonToString } from './helper'
import classes from './index.module.scss'
import {
  changeIsDisableBlockNavigate,
  selectCompanyTypeTemplate,
  selectDefaultTemplate,
  selectIsDisableBlockNavigate,
  selectIsFiinGateTemplate,
  selectName,
  selectPanelById,
  selectPanelId,
} from './store/slice'

const ButtonSubmit = ({ saveTemplate, goToTemplateTable, apply }) => {
  const dispatch = useDispatch()

  const name = useSelector(selectName)
  const panelId = useSelector(selectPanelId)
  const panelById = useSelector(selectPanelById)
  const isFiinGateTemplate = useSelector(selectIsFiinGateTemplate)
  const templateId = useSelector(selectDefaultTemplate).templateId
  const defaultTemplate = useSelector(selectDefaultTemplate)
  const companyInfo = useSelector(selectCompanyInfo)
  const companyTypeTemplate =
    useSelector(selectCompanyTypeTemplate) || companyInfo.companyType
  const isDisableBlockNavigate = useSelector(selectIsDisableBlockNavigate)

  useEffect(() => {
    if (isDisableBlockNavigate) {
      apply({
        templateId,
        templateName: name,
        panels: panelId.map((id) => panelById[id]),
        isNotHasChange,
        isFiinGateTemplate,
      })
    }
  }, [isDisableBlockNavigate])

  const isNotHasChange =
    name.trim() === defaultTemplate.templateName &&
    jsonToString(panelId.map((id) => ({ ...panelById[id], id: undefined }))) ===
      jsonToString(
        defaultTemplate.panelId.map((id) => ({
          ...defaultTemplate.panelById[id],
          id: undefined,
        })),
      )

  const applySetting = () => {
    dispatch(changeIsDisableBlockNavigate())
  }

  const isActive = companyTypeTemplate === companyInfo.companyType

  return (
    <>
      <Button
        saveTemplate={saveTemplate}
        action={goToTemplateTable}
        isButtonSave
      >
        <Element
          style={{ background: '#0553A5', color: '#FFFFFF' }}
          className={classes.btnSave}
        >
          <Translate value="preferenceSetting.BTN_SAVE" />
        </Element>
      </Button>
      <Element
        style={{
          background: '#2C73E8',
          color: '#FFFFFF',
          opacity: isActive ? 1 : 0.4,
        }}
        className={classes.btnApply}
        onClick={isActive ? applySetting : undefined}
      >
        <Translate value="preferenceSetting.APPLY" />
      </Element>
    </>
  )
}

export default ButtonSubmit
